// extracted by mini-css-extract-plugin
export default {"tabs":"Deals_tabs__yG6pr"};